import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { MouseEventHandler } from "react";

interface ArrowNavProps {
  title: string;
  fontColor?: string;
  borderColor?: string;
  hoverBorderColor?: string;
  fontWeight?: string;
  iconColor?: string;
  icon?: IconProp;
  fontSize?: string;
  onClick?: MouseEventHandler;
}

const ArrowNav: React.FC<ArrowNavProps> = ({ title, fontColor, borderColor, hoverBorderColor, fontWeight, iconColor, icon, fontSize, onClick }) => {
  return (
    <div className="flex flex-row space-x-2 items-center" onClick={onClick}>
      <p className={`${fontSize ?? 'text-sm'} ${fontWeight ?? 'font-bold'} border-b-2 ${borderColor ?? 'border-transparent'} ${hoverBorderColor ?? 'hover:border-white'} cursor-pointer ${fontColor ?? 'text-white'}`}>{title}</p>
      <FontAwesomeIcon icon={icon ?? faArrowRight} className={`cursor-pointer ${iconColor ?? (fontColor ?? 'text-white')}`} />
    </div>
  );
};

export default ArrowNav;
